module.exports = __webpack_public_path__ + "static/media/02.9321bb45.jpg";